import { render, staticRenderFns } from "./ShiftExpandItem.vue?vue&type=template&id=4d22a6c6"
import script from "./ShiftExpandItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftExpandItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports